import { defineStore } from 'pinia';
import { IContactListStore, IContactListItem } from '../utils/interfaces';

export const useContactListStore = defineStore('contactListStore', {
  state: (): IContactListStore => ({
    apiError: false,
    dataError: false,
    dataReady: false,
    contactListItems: [] as IContactListItem[],
  }),
  getters: {
    getContactListItems: (state): IContactListItem[] => state.contactListItems
  },
  actions: {
    loadContactListItems(contactListItems: IContactListItem[]) {
      this.contactListItems = contactListItems;
      this.dataReady = true;
      this.apiError = false;
      this.dataError = false;
    }
  }
});
